import { FallbackProps } from './error-boundary';
import css from './dev-error.module.scss';

export interface DevErrorProps extends FallbackProps {
  label?: string;
}

export function DevError({ label, error, reset }: DevErrorProps) {
  return (
    <div className={css.error}>
      <h5>Development error {label}</h5>
      <p className={css.reason}>{error.message ?? 'unknown'}</p>
      <button className={css.button} onClick={() => reset()}>
        Retry
      </button>
    </div>
  );
}
